import { CreditCard, Wallet } from "lucide-react";
import { PAYMENT_TAB_PERM as P } from "../perms";
import type { SubsectionTab } from "../subsection";
import { MethodsCard } from "./MethodsCard";
import { CrmStripeCard } from "./CrmStripeCard";

/**
 * Settings -> Payments, in the order the questions are asked.
 *
 * The list first, because it is the decision: which ways this desk lets an
 * invoice be settled. The Stripe credentials second, because they are what one
 * entry on that list needs in order to work - a panel an operator opens once and
 * then forgets, unlike the switches above it.
 *
 * The card panel used to live under Integrations, and its old URL still answers
 * (see `../integrations/index.tsx`). It was moved here because Integrations is
 * about outside services this CRM reads FROM - the register, the mailbox, the
 * browser - and money coming in was the one entry that did not fit the sentence.
 * Its keys are still a credential; they are just a credential belonging to a
 * payment method, and the method is what an operator comes looking for.
 */
// The permissions are referenced, not typed in. They live in `../perms` beside
// every other Settings gate, because `crm/nav.ts` reads the same list to decide
// whether Settings appears at all and cannot import this file - that would pull
// two panels into the sidebar's module graph.
export const PAYMENT_TABS: SubsectionTab[] = [
  { path: "methods", key: "methods", icon: Wallet, perm: P.methods, panel: MethodsCard },
  { path: "card-payments", key: "cardPayments", icon: CreditCard, perm: P["card-payments"], panel: CrmStripeCard },
];
